import React from 'react'
import { CaseData } from './Cases'
import { COUNTRY, currencyConfig } from '../../../../common/utils/constants'
import styles from './Cases.module.scss'

interface CaseItemProps {
  data: CaseData
  onExpand: () => void
}



const { symbol, locale } = currencyConfig[COUNTRY] || currencyConfig.ru

export const CaseItem: React.FC<CaseItemProps> = ({ data, onExpand }) => {
  const { title, profit } = data

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat(locale).format(value) + ' ' + symbol
  }

  return (
    <div className={styles.card}>
      <h3 className={styles.cardTitle}>{title}</h3>
      <div className={styles.profitBlock}>
        <div className={styles.profitLabel}>Операционная прибыль /мес</div>
        <div className={styles.profitRow}>
          <span className={styles.profitLabelText}>Было</span>
          <span className={styles.profitValue}>{formatCurrency(profit.before)}</span>
        </div>
        <div className={styles.profitRow}>
          <span className={styles.profitLabelText}>Стало</span>
          <span className={styles.profitValue}>{formatCurrency(profit.after)}</span>
        </div>
        <div className={styles.profitGrowth}>
          <span className={styles.growthValue}>+{formatCurrency(profit.growth)}</span>
          <span className={styles.growthPercent}>(+{profit.growthPercent}%)</span>
        </div>
      </div>
      <button className={styles.expandButton} onClick={onExpand}>
        Развернуть →
      </button>
    </div>
  )
}
